document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper--home');
  if (!header) return;

  // Sums every bar sitting above the header in the header group (the native
  // announcement bar, the marquee announcement bar, any future bar added
  // there) rather than one hardcoded selector, so the fixed header always
  // starts right below whatever's actually stacked above it.
  const setAnnouncementBarHeight = () => {
    const groupSections = document.querySelectorAll('.shopify-section-group-header-group');
    let height = 0;
    groupSections.forEach((section) => {
      if (section.querySelector('.header-wrapper')) return;
      height += section.offsetHeight;
    });
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  };

  setAnnouncementBarHeight();
  window.addEventListener('resize', setAnnouncementBarHeight);
  document.addEventListener('shopify:section:load', setAnnouncementBarHeight);
  document.addEventListener('shopify:section:unload', setAnnouncementBarHeight);
  document.addEventListener('shopify:section:reorder', setAnnouncementBarHeight);

  // Hide on scroll down, reveal on scroll up. Ignored near the very top so the
  // header doesn't flicker hidden on the first small scroll of the page.
  let lastScrollY = window.scrollY;
  let ticking = false;

  const revealThreshold = () => header.offsetHeight;

  const onScroll = () => {
    const currentScrollY = window.scrollY;
    const pastAnnouncementBar = currentScrollY > revealThreshold();

    if (currentScrollY <= revealThreshold()) {
      header.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY) {
      header.classList.add('is-hidden');
    } else if (currentScrollY < lastScrollY) {
      header.classList.remove('is-hidden');
    }

    // Once scrolled past the announcement bar it's no longer there to sit
    // under, so pin the header flush to the top instead of leaving the gap
    // where it used to be reserved.
    header.classList.toggle('is-past-announcement-bar', pastAnnouncementBar);

    lastScrollY = currentScrollY;
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(onScroll);
    },
    { passive: true }
  );
});
